import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { Site } from './site.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SaisieRevendication {
    static jsonMap = {
        id: { key: 'idMouvement', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        libelleProduit: { key: 'libelleProduit', optional: true, default: '' },
        millesime: { key: 'millesime', optional: true, default: '' },
        cepages: { key: 'idsCepages', optional: true, default: () => [] },
        destinations: { key: 'idsDestinations', optional: true, default: () => [] },
        date: { key: 'date', converter: new DateConverter(), optional: true },
        entreposage: { key: 'idSite', converter: new (DataIdConverterFactory.build(Site, 'site'))(), optional: true },
        logement: { key: 'logement', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        degre: { key: 'degre', optional: true },
        volume: { key: 'volume', optional: true },
        observation: { key: 'observation', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        environnementLabels: { key: 'idsEnvironnementLabels', optional: true, default: () => [] },
        autresEnvironnementLabels: { key: 'autresEnvironnementLabels', optional: true, default: '' }
    };

    id: number;
    codeProduit: string;
    libelleProduit: string;
    millesime: string;
    cepages: number[];
    destinations: number[];
    date: moment.Moment;
    entreposage: Site;
    logement: string;
    numeroLot: string;
    degre: number;
    volume: number;
    observation: string;
    type: string;
    environnementLabels: number[];
    autresEnvironnementLabels: string;
}
